<template>
  <zm-dialog :visible.sync="visible" class="comparison-dialog comparison-dialog--whiteboard" show-close :before-close="handleBeforeClose">
    <h1 class="comparison-dialog__title" slot="title">{{ $t('billing.zoom_whiteboard_plan_comparsion') }}</h1>
    <FullComparisonTable v-if="$context.is.desktop" :treeData="treeData" :colConfig="colConfig" :value="planType" />
    <PlanComparisonMobile v-else class="comparison-dialog__comparison-tree-table-mobile" :treeData="treeData" :colConfig="colConfig">
      <template #button="{ col }">
        <template v-if="!col.hideBtn">
          <i v-if="col.category === planType || col.selected" class="zm-icon-ok no-event-btn" tabindex="-1" :aria-label="col.title + ' Selected'" />
          <zm-tooltip v-else-if="col.btn && col.btn.disabledTips" :disabled="!col.btn.disabled">
            <p slot="content" v-html="col.btn.disabledTips" @click="onSubmitFormClick(col, $event)" />
            <div>
              <zm-button :type="col.btn.type" round :disabled="col.btn.disabled" tabindex="-1" :aria-label="col.btn.ariaLabel" @click="col.btn.callback(col)">{{ col.btn.label }}</zm-button>
            </div>
          </zm-tooltip>
          <zm-button v-else-if="col.btn" :type="col.btn.type" round :disabled="col.btn.disabled" tabindex="-1" :aria-label="col.btn.ariaLabel" @click="col.btn.callback(col)">{{ col.btn.label }}</zm-button>
          <div v-else class="empty-btn" aria-hidden="true" />
        </template>
      </template>
    </PlanComparisonMobile>
  </zm-dialog>
</template>

<script type="text/jsx">
import { mapGetters, mapState } from 'vuex';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import { planTypes, BASE_PLAN_SUB_TYPES, contactUsPath, A_LINK_TAG_NAME } from '@/common/constants';
import ComparisonDataMixins from './full-comparison-dialog';
import FullComparisonTable from '@/components/full-comparison-table/full-comparison-table.vue';
import UsageTypeMixins from '@/views/checkout/address/mx-usage-type';
import { mapMutations } from 'vuex';
import { translation } from '@/plugins/i18n';

const getDefaultStatusMap = () => {
  return {
    disabled: true,
    link: contactUsPath,
    disabledTips: translation('billing.error.can_not_bought_plan_tips'),
  }
}
export default {
  name: 'FullComparisonDialog',
  mixins: [ConfirmComponent, ComparisonDataMixins, UsageTypeMixins],
  props: {
    planType: String
  },
  components: {
    FullComparisonTable,
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters([
      'getCurrentBasePlanInfo',
      'boughtPlans',
      'basicConfig',
      'currentEditPlan'
    ]),
    isBulkLicenseAccount() {
      return this.basicConfig?.isBulkLicenseAccount && this.$context.is.edit;
    },
    colConfig() {
      const checkIsSelected = (val) => this.planType === val;

      return [
        {
          title: this.$t('billing.zoom_whiteboard.title'),
          key: 'whiteBoard',
          category: planTypes.ZOOM_WHITEBOARD,
          selected: this.$context.is.add2cart && this.boughtPlans.find(p => p.category === BASE_PLAN_SUB_TYPES.WHITEBOARD_BASIC),
          isSelected: checkIsSelected(planTypes.ZOOM_WHITEBOARD),
          btn: Object.assign({}, {
            callback: this.handleSwitchWhiteboardPlan.bind(this),
            label: this.$t('billing.common.select'),
            disabled: false,
            link: '/',
            type: 'primary',
          }, this.isBulkLicenseAccount || (this.basicConfig.downSellData.disableDownSell && this.currentEditPlan?.category === BASE_PLAN_SUB_TYPES.WHITEBOARD_PLUS) ? getDefaultStatusMap() : {}),
          visible: true,
        },
        {
          title: this.$t('billing.zoom_whiteboard_plus.title'),
          key: 'whiteBoardPlus',
          category: planTypes.ZOOM_WHITEBOARD_PLUS,
          selected: this.$context.is.add2cart && this.boughtPlans.find(p => p.category === BASE_PLAN_SUB_TYPES.WHITEBOARD_PLUS),
          isSelected: checkIsSelected(planTypes.ZOOM_WHITEBOARD_PLUS),
          btn: Object.assign({}, {
            callback: this.handleSwitchWhiteboardPlan.bind(this),
            label: this.$t('billing.common.select'),
            disabled: false,
            link: '/',
            type: 'primary'
          }, this.isBulkLicenseAccount ? getDefaultStatusMap() : {}),
          visible: true,
        },
      ];
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(v) {
        v && this.$tracking.buyInteraction('product details',
          'full plan comparison - impression');
      }
    }
  },
  methods: {
    ...mapMutations(['updateSelectPlanByCategory', 'removePlan']),
    onSubmitFormClick(col, event) {
      if (event?.target?.tagName === A_LINK_TAG_NAME) {
        this.$tracking.buyInteraction(
          'product details',
          `full plan comparison select - ${col?.category || ''} - contact form`
        );
      }
    },
    handleBeforeClose() {
      this.$tracking.buyInteraction('product details', 'full plan comparison - exit');
      this.handleCancel();
    },
    handleRowClick(row) {
      if (row.subTitle) {
        const featureCol = document.querySelector(`.${row.id}-sub-title`);
        let cel = null;
        let expandBtn = null;
        if (featureCol) {
          cel = featureCol.parentElement;
        }
        if (cel) {
          expandBtn = cel.querySelector('.zm-table__expand-icon');
        }
        if (expandBtn) {
          expandBtn.click();
        }
      }
    },
    arraySpanMethod({ row, columnIndex }) {
      if (row.subTitle) {
        return columnIndex === 0 ? [1, 10] : [0, 0];
      }
    },
    handleSwitchWhiteboardPlan(col) {
      if (col?.btn?.disabled) return;

      this.$tracking.buyInteraction('product details', `full plan comparison select - ${col?.category}`);

      switch (col.category) {
        case planTypes.ZOOM_WHITEBOARD:
          return this.switchZWB(col);
        case planTypes.ZOOM_WHITEBOARD_PLUS:
          return this.switchZWBPlus(col);
      }
    },
    switchZWB() {
      this.jump(BASE_PLAN_SUB_TYPES.WHITEBOARD_BASIC);
    },
    switchZWBPlus() {
      this.jump(BASE_PLAN_SUB_TYPES.WHITEBOARD_PLUS);
    },
    jump(category) {
      const target = this.getSelectedPlans.find(item => item.type === planTypes.ZOOM_WHITEBOARD);
      if (target) {
        const { billing_cycle, cartInfo, plan_code } = target;
        this.removePlan(plan_code);
        this.updateSelectPlanByCategory({
          category,
          cartInfo,
          billingCycle: billing_cycle
        });
        this.handleCancel();
      }
    }
  },
}
</script>
<style lang="scss">
@import '@/styles/responsive.scss';

.comparison-dialog {
  .zm-dialog {
    width: 1000px;
  }
  
  &.comparison-dialog--whiteboard {
    .zm-dialog {
      @include media(mobile) {
        $verticalMargin: 6vh;
        margin-top: $verticalMargin !important;
        margin-bottom: 0 !important;
        height: calc(100% - #{$verticalMargin} * 2) !important;
      }
      @include media(tablet) {
        $verticalMargin: 15vh;
        margin-top: $verticalMargin !important;
        margin-bottom: 0 !important;
        height: calc(100% - #{$verticalMargin} * 2) !important;
      }
      @include media(mobile, tablet) {
        $dialogWidth: calc(100% - 24px);
        padding: 24px 12px 12px !important;
        width: $dialogWidth !important;
        min-width: $dialogWidth !important;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        &__header {
          flex-shrink: 0;
          width: 100%;
        }
        &__headerbtn {
          top: 10px;
          right: 15px;
        }
        &__body {
          flex-grow: 1;
          width: 100%;
          overflow: hidden;
        }
      }
    }
  }

  &__title {
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 150%;
    color: #00053d;
    text-align: center;
  }
  
  &__comparison-tree-table-mobile {
    .button-area {
      box-sizing: content-box;
      padding-top: 12px;
      height: 38px;
    }
  }
}
</style>
